import { createWebHistory, createRouter } from 'vue-router'
import routes from '@/router/routes.js'
import { authorizationCheck } from '@/router/guards.js'
import store from '@/store'
import BUSINESS_DATA from '@/configs/businessConstants'
import { updateCurrentUrl } from '@/mixins/global/BrowserBackProtectionMixin'


const router = createRouter({
  history: createWebHistory(),
  routes
})

// Router Configuration
router.beforeEach((to, from, next) => {
  if (to.name) { // Only start if not initial load
    $this.$NProgress.start();
  }
  if (store.state.promptOnRouteChange !== undefined) {
    if (window.confirm(store.state.promptOnRouteChange)) {
      store.state.promptOnRouteChange = undefined
      next()
    } else {
      next(false)
    }
  } else {
    next()
  }
})

router.beforeEach(authorizationCheck)
router.afterEach((to, _from) => {
  const vm = window.vue
  if(!vm) {
    console.warn('No Vue instance found in router afterEach')
  }

  const currentRouteName = to.name
  let targetTitle = vm.$i18n.t('i18nRouteTitle.'+currentRouteName)
  if(targetTitle && targetTitle !== ('i18nRouteTitle.'+currentRouteName)){
  // use translated title
  } else{
    targetTitle = to.meta.title ?? to.name
  }

  vm.$store.commit('App/SET_APP_HEADER_TITLE',targetTitle)
  vm.$store.commit('App/SET_APP_DOCUMENT_TITLE',(to.meta.documentTitle ?? targetTitle) + ' - ' + BUSINESS_DATA.APP_TITLE)
  console.log(
    {
      currentRouteName,
      targetTitle,
    }
  )
  // Update current URL for browser back protection
  if (to && to.fullPath) {
    console.log("UpdateCurrentUTL",to)
    updateCurrentUrl(to.fullPath)
  }
  $this.$NProgress.done();
})

export default router
